import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BsPersonFill } from 'react-icons/bs';
import { BASE_URL, USER_URL } from '../../constant/api';
import { useParams, useNavigate } from 'react-router-dom';

function CustomerView() {
  const [products, setProducts] = useState([]);
  const [customerData, setCustomerData] = useState({});
  // const token = localStorage.getItem('token');
  const { productId } = useParams();
  const navigate = useNavigate();

  // Fetch customer and product data
  useEffect(() => {
    if (!productId) {
      navigate('/admin/customers');
      return;
    }

    const fetchCustomerData = async () => {
      try {
        const response = await USER_URL.get(`/accounts/admin/customers/${productId}/`, {
          // headers: { Authorization: `Token ${token}` },
        });
        if (response.data?.data) {
          setCustomerData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching customer data:', error.message || error);
      }
    };

    const fetchProductData = async () => {
      try {
        const response = await USER_URL.get(`/products/`, {
          // headers: { Authorization: `Token ${token}` },
        });
        if (response.data?.Data) {
          setProducts(response.data.Data);
        }
      } catch (error) {
        console.error('Error fetching products:', error.message || error);
      }
    };

    fetchCustomerData();
    fetchProductData();
  }, [productId, navigate, ]);

  // Helper function to format full address with fallback
  const formatAddress = (city, address, postCode) => {
    if (!city && !address && !postCode) {
      return "No address available";
    }

    const formattedCity = city ? `${city},` : '';
    const formattedAddress = address ? `${address} -` : '';
    const formattedPostCode = postCode ? postCode : '';

    return `${formattedCity} ${formattedAddress} ${formattedPostCode}`.trim() || "No address available";
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <h1 className="mb-5 text-green-500 font-semibold">SUB ADMIN A</h1>

      {/* Profile Section */}
      <div className="flex items-center space-x-6 mb-8">
        <div className="w-24 h-24 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center">
          <BsPersonFill className="text-gray-500 text-7xl" />
        </div>
        <h2 className="text-3xl font-bold text-gray-800">
          {customerData.username || 'Customer Name'}
        </h2>
      </div>

      {/* Personal Info Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">Personal Info</h2>
          <div className="space-y-4">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Name</span>
              <p className="text-lg font-semibold text-gray-800">{customerData.username || "No name available"}</p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Email</span>
              <p className="text-lg font-semibold text-gray-800">{customerData.email || "No email available"}</p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Phone Number</span>
              <p className="text-lg font-semibold text-gray-800">{customerData.mobile_number || "No phone number available"}</p>
            </div>
          </div>
        </div>

        {/* Address Section */}
        <div>
          <div className="space-y-4 mt-12">
            {/* First Address */}
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1"> Address</span>
              <p className="text-lg font-semibold text-gray-800">
                {formatAddress(customerData.city, customerData.address, customerData.post_code)}
              </p>
            </div>

            {/* Second Address (if available) */}
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1"> Address 2</span>
              <p className="text-lg font-semibold text-gray-800">
                {formatAddress(
                  customerData.address2 || customerData.address,
                  customerData.city,
                  customerData.post_code
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Most Purchased Products Section */}
      <div>
        <h2 className="text-2xl font-bold mb-4 mt-16">Customer Most Purchased Products</h2>

        {/* Horizontal scroll container for products */}
        <div className="overflow-x-auto bg-gray-50 p-2">
          <div className="flex space-x-4 w-[200px]"> {/* Ensure it doesn't shrink */}
            {products.map((product) => (
              <div
                key={product.id}
                className="p-4 min-w-[150px] bg-white border rounded-lg shadow-sm flex flex-col items-center hover:shadow-lg hover:border-green-400 transition-all"
              >
                <img
                  src={product.product_images && product.product_images.length > 0
                    ? product.product_images[0].image
                    : 'https://via.placeholder.com/100'}
                  alt={product.name || 'Product'}
                  className="mb-2 w-24 h-24 object-cover rounded transition-transform transform hover:scale-105"
                />
                <p className="text-sm font-semibold text-gray-800 text-center">
                  {product.name || 'Unnamed Product'}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
}

export default CustomerView;

